import { getSalaryCompensationByEmployeeId } from "../services/salaryCompensation";
import { useEffect, useState } from "react";

const useGetEmployeeCompensationDetById = (editEmployeeID) => {
  const [employeeCompensation, setEmployeeCompensation] = useState([]);
  const [activeCompensation, setActiveCompensation] = useState([]);
  const [isDataLoad, setIsDataLoad] = useState(false);

  const parseData = (data) => (typeof data === "string" ? JSON.parse(data) : data);

  const GetCompensationDetail = async (employeeId) => {
    if (!employeeId || employeeId === 0) {
      setEmployeeCompensation([]);
      return;
    }

    try {
      const params = {
        p_companyid: localStorage.getItem("companyid"),
        p_plantid: 1,
        p_id_employee: employeeId,
      };

      const response = await getSalaryCompensationByEmployeeId(params);

      if (response?.length > 0) {
        
        const items = parseData(response[0].compensation_item_details);
        const compensationArray = Array.isArray(items) ? items : [];

        setEmployeeCompensation(compensationArray);
        setIsDataLoad(true);
       
      } else {
        setEmployeeCompensation([]);
        setActiveCompensation(null);
      }
    } catch (error) {
      console.error("Failed to fetch compensation details:", error);
    }
  };

  useEffect(() => {
    if (!isDataLoad && editEmployeeID) {
      GetCompensationDetail(editEmployeeID);
    }
  }, [editEmployeeID, isDataLoad]);

  return {
    employeeCompensation,
    activeCompensation,
    setEmployeeCompensation,
    setActiveCompensation,
    EmployeeCompensationDetail: GetCompensationDetail,
  };
};

export default useGetEmployeeCompensationDetById;
